import { Category } from "../components/pages/categories/Category";
import { Index } from "../components/pages/companies";
import { Invoice } from "../components/pages/invoice/Invoice";
import { SearchResult } from "../components/pages/powerSearch/SearchResult";
import { Subscription } from "../components/pages/subscription/Subscription";
import { User } from "../components/pages/user/User";
import { ROUTE_PATHS } from "./routePath";
import { SecurityProfile } from "../components/pages/security/SecurityProfile";
import { Reporting } from "../components/pages/reporting/Reporting";
import { TermsOfService } from "../components/pages/TermsOfService";

export const routes = [
  {
    path: ROUTE_PATHS.TERMS_OF_SERVICE,
    Component: TermsOfService,
    exact: true,
  },
  {
    path: ROUTE_PATHS.HOME,
    Component: () => null,
    exact: true,
  },
  {
    path: ROUTE_PATHS.COMPANY_LIST,
    Component: Index,
    exact: true,
  },
  {
    path: ROUTE_PATHS.CATEGORY_LIST,
    Component: Category,
    exact: true,
  },
    {
    path: ROUTE_PATHS.SECURITY_LIST,
    Component: SecurityProfile,
    exact: true,
  },
  {
    path: ROUTE_PATHS.ADD_USERS,
    Component: User,
    exact: true,
  },
  {
    path: ROUTE_PATHS.INVOICE_LIST,
    Component: Invoice,
    exact: true,
  },
  {
    path: ROUTE_PATHS.SUBSCRIPTION_LIST,
    Component: Subscription,
    exact: true,
  },
  {
    path: ROUTE_PATHS.SEARCH_RESULT,
    Component: SearchResult,
    exact: true,
  },
  {
    path: ROUTE_PATHS.REPORTING,
    Component: Reporting,
    exact: true,
  },
];
